import { FC } from 'react';
import { Badge, Nav } from 'rsuite';
import './Navbar.scss';
import { INavigationTabs } from '../routing/routing-helper/provider-navigation';

interface Props {
  active: string;
  onSelect: (eventKey: string) => void;
  tabsList: INavigationTabs[];
}

export const Navbar: FC<Props> = (props) => {
  const { tabsList, active, onSelect } = props;

  return (
    <div className="card">
      <Nav appearance="subtle" activeKey={active} onSelect={onSelect} data-cy="navigation-tabs">
        {
          tabsList.map((tab) => (
            <Nav.Item
              key={tab.value}
              eventKey={tab.value}
              data-cy={tab.value}
            >
              {tab.label}
              {
                tab?.enableBadge && (
                  <Badge
                    content={tab?.badgeCount}
                    className="ms-2 fw-bold"
                    data-cy={`${tab.value}-badge`}
                  />
                )
              }
            </Nav.Item>
          ))
        }
      </Nav>
    </div>
  );
};